import { type Observable as ObservableType, Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/of';

import 'rxjs/add/operator/mergeMap';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default <TRest, TDomain>(
	rest: ObservableType<TRest>,
	transformFunc: (arg1: TRest) => TDomain,
): ObservableType<TDomain> =>
	rest.mergeMap((payload: TRest): ObservableType<TDomain> => Observable.of(transformFunc(payload)));
